import { render, staticRenderFns } from "./AlbumCard.vue?vue&type=template&id=2b120e0b&scoped=true&"
import script from "./AlbumCard.vue?vue&type=script&lang=js&"
export * from "./AlbumCard.vue?vue&type=script&lang=js&"
import style0 from "./AlbumCard.vue?vue&type=style&index=0&id=2b120e0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b120e0b",
  null
  
)

export default component.exports